import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SettingsContext } from '@contexts';

function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(null);
    const value = { settings, setSettings };
    return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export default SettingsProvider;

SettingsProvider.propTypes = {
    children: PropTypes.node.isRequired
};
